import { env } from '@shared/config/env';

import { isSupportedLanguage } from '../config/languages';

/** Landing URL in the cabinet language. English stays on the unprefixed path. */
export const landingHref = (language: string, ref?: string): string => {
  const code = isSupportedLanguage(language) ? language : 'en';
  const path = code === 'en' ? '/' : `/${code}/`;
  const url = new URL(path, `${env.LANDING_BASE_URL}/`);

  if (ref) {
    url.searchParams.set('ref', ref);
  }

  return url.toString();
};
